module.exports = __webpack_public_path__ + "img/58.e21cb551.jpg";